export const NOTICE_CATEGORIES = ['all', 'update', 'event', 'store']

export const NOTICE_DATA = [
  {
    id: '1',
    category: 'update',
    title: '포카판 UI 대규모 업데이트!',
    description:
      '새로운 UI 디자인 적용! 더 깔끔하고 직관적인 인터페이스를 경험해 보세요. 디자인뿐만 아니라 다양한 기능 개선이 이루어졌습니다. 사용자가 편리하게 이용할 수 있는 요소들이 추가되었어요.',
    createdAt: '2024-02-15',
    image: '/images/NoticeImage.svg'
  },
  {
    id: '2',
    category: 'update',
    title: '검색 기능이 더욱 강력해졌어요!',
    description:
      '이제 태그 검색과 정렬 기능을 활용해 원하는 포카를 쉽게 찾아보세요. 사용자 경험을 극대화하기 위해 검색 결과의 정확도도 대폭 향상되었습니다. 다양한 필터링 옵션으로 더욱 세부적으로 검색이 가능합니다.',
    createdAt: '2024-02-10',
    image: '/images/NoticeImage.svg'
  },
  {
    id: '3',
    category: 'update',
    title: '프로필 커스터마이징 기능 추가',
    description:
      '프로필 사진 변경 및 소개글 작성 기능이 추가되었습니다! 이제 자신의 개성을 표현할 수 있는 다양한 옵션들이 제공됩니다. 사진을 업로드하고 간단한 소개글을 작성하여 다른 유저들에게 나를 소개할 수 있어요.',
    createdAt: '2024-01-30',
    image: '/images/NoticeImage.svg'
  },
  {
    id: '4',
    category: 'event',
    title: '누락포카 제보로 더 완벽해진 포카 데이터',
    description:
      '찾고 있던 포카가 없다고요? 포카판에 제보해 주세요! 포카판에서는 유저들이 직접 새로운 포카를 제보할 수 있어요. 제보된 포카는 신속하게 검토 후 업데이트되며, 사용자들의 의견을 반영하여 더 완벽한 데이터베이스를 만듭니다.',
    createdAt: '2023-09-20',
    image: '/images/NoticeImage.svg'
  },
  {
    id: '5',
    category: 'event',
    title: '포인트 이벤트 진행 중!',
    description:
      '포카판에서 활동하면 포인트 적립! 적립한 포인트로 다양한 혜택을 누려보세요. 이벤트에 참여하면 추가적인 보상도 지급되며, 포인트를 모으면 더 큰 혜택을 받을 수 있어요. 유저들은 더 많은 활동으로 점수를 쌓을 수 있습니다.',
    createdAt: '2024-03-01',
    image: '/images/NoticeImage.svg'
  },
  {
    id: '6',
    category: 'event',
    title: '친구 초대 이벤트!',
    description:
      '친구를 초대하면 포인트 지급! 초대받은 친구도 혜택을 받을 수 있어요. 초대된 친구가 활동을 시작하면, 포인트는 더 빠르게 적립됩니다. 친구와 함께 활동하면서 다양한 이벤트와 보상을 함께 받을 수 있는 기회를 놓치지 마세요!',
    createdAt: '2024-02-25',
    image: '/images/NoticeImage.svg'
  },
  {
    id: '7',
    category: 'store',
    title: '한정판 포카 출시!',
    description:
      '특정 기간 동안만 구매할 수 있는 한정판 포카를 놓치지 마세요! 인기 있는 포카들이 한정 수량으로 출시되며, 컬렉터들에게는 특별한 의미가 있는 상품들이 포함됩니다. 매일 업데이트되는 새로운 포카를 확인하세요!',
    createdAt: '2024-02-05',
    image: '/images/NoticeImage.svg'
  },
  {
    id: '8',
    category: 'store',
    title: '포카 세트 특별 할인!',
    description:
      '인기 포카 세트를 할인된 가격으로 만나보세요. 한정판 세트부터, 인기 캐릭터들로 구성된 다양한 세트까지, 할인된 가격으로 구매할 수 있는 기회입니다. 포카 팬이라면 이 기회를 놓치지 마세요.',
    createdAt: '2024-01-20',
    image: '/images/NoticeImage.svg'
  },
  {
    id: '9',
    category: 'store',
    title: '포인트로 교환 가능한 상품 추가!',
    description:
      '이제 포인트로 교환할 수 있는 상품이 더 다양해졌어요. 포카 관련 상품뿐만 아니라, 실생활에서 유용한 다양한 제품들도 추가되었습니다. 포인트를 모으면 원하는 상품을 교환할 수 있는 기회가 넓어졌습니다.',
    createdAt: '2024-01-10',
    image: '/images/NoticeImage.svg'
  }
]
